const HOTJAR_SCRIPT_PATTERN = "static.hotjar.com";

export function initHotjar(siteId) {
  if (!siteId) return;
  (function(h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function() {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: Number(siteId), hjsv: 6 };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
}

export function stopHotjar() {
  document.querySelectorAll("script").forEach(s => {
    if (s.src && s.src.includes(HOTJAR_SCRIPT_PATTERN)) s.remove();
  });
  delete window.hj;
  delete window._hjSettings;
}
